import { useAutoExpenses } from "@/lib/useAutoExpenses";
import { brl } from "@/lib/format";
import { Loader2 } from "lucide-react";

const sum = (a) => a.reduce((s, e) => s + (Number(e.value) || 0), 0);

function Card({ testId, title, subtitle, fixas, variaveis, fat, loading }) {
  const desp = fixas + variaveis;
  const res = fat - desp;
  return (
    <div className="min-w-[230px] flex-1 rounded-xl border border-slate-800 bg-slate-950 p-4" data-testid={testId}>
      <p className="truncate font-semibold text-slate-100" title={title}>{title}</p>
      <p className="mb-3 text-[11px] text-slate-500">{subtitle}</p>
      {loading ? <Loader2 className="h-5 w-5 animate-spin text-slate-500" /> : (
        <div className="space-y-1 text-sm">
          <div className="flex justify-between"><span className="text-slate-400">Fixas</span><span className="font-mono text-sky-300">{brl(fixas)}</span></div>
          <div className="flex justify-between"><span className="text-slate-400">Variáveis</span><span className="font-mono text-amber-300">{brl(variaveis)}</span></div>
          <div className="flex justify-between border-t border-slate-800 pt-1"><span className="text-slate-300">Despesas</span><span className="font-mono text-rose-300" data-testid={`${testId}-despesas`}>{brl(desp)}</span></div>
          <div className="flex justify-between"><span className="text-slate-300">Faturamento</span><span className="font-mono text-emerald-300" data-testid={`${testId}-faturamento`}>{brl(fat)}</span></div>
          <div className="flex items-end justify-between border-t border-slate-800 pt-2">
            <span className="text-xs uppercase tracking-wider text-slate-500">Resultado</span>
            <span className={`whitespace-nowrap font-mono text-base font-bold ${res >= 0 ? "text-emerald-300" : "text-rose-300"}`} data-testid={`${testId}-resultado`}>{brl(res)}</span>
          </div>
          {fat > 0 && <p className="text-right text-[11px] text-slate-500">Margem {Math.round((res / fat) * 1000) / 10}%</p>}
        </div>
      )}
    </div>
  );
}

function BaseCard({ base, y, m, period, manual }) {
  const auto = useAutoExpenses(y, m, period, base.id);
  const mine = manual.filter((e) => e.base_id === base.id);
  const desp = [...auto.items, ...mine.filter((e) => e.kind !== "receita")];
  return (
    <Card testId={`compare-base-${base.id}`} title={base.name} subtitle="Automáticas + lançamentos da base" loading={auto.loading}
      fixas={sum(desp.filter((e) => e.type === "fixa"))} variaveis={sum(desp.filter((e) => e.type !== "fixa"))}
      fat={sum(mine.filter((e) => e.kind === "receita"))} />
  );
}

// Comparativo lado a lado: uma coluna por base + os lançamentos de "Todas as bases", que não são rateados.
export function BaseComparison({ bases, y, m, period, manual }) {
  const shared = manual.filter((e) => !e.base_id);
  const sd = shared.filter((e) => e.kind !== "receita");
  return (
    <div className="space-y-2" data-testid="compare-bases">
      <div className="flex gap-3 overflow-x-auto pb-2">
        {bases.map((b) => <BaseCard key={b.id} base={b} y={y} m={m} period={period} manual={manual} />)}
        <Card testId="compare-base-geral" title="Todas as bases (geral)" subtitle="Lançamentos sem base específica" loading={false}
          fixas={sum(sd.filter((e) => e.type === "fixa"))} variaveis={sum(sd.filter((e) => e.type !== "fixa"))}
          fat={sum(shared.filter((e) => e.kind === "receita"))} />
      </div>
      <p className="text-xs text-slate-500">
        Os lançamentos de “Todas as bases” não são divididos entre as bases. Um colaborador ligado a mais de uma base aparece em cada uma delas, por isso a soma das colunas pode passar do total geral.
      </p>
    </div>
  );
}
